module.exports = __webpack_public_path__ + "./assets/img_jiaoxi_grey@2x__fd26a112c751618f57e5d5db68326c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_jiaoxi_grey@2x.jpg
// module id = 618
// module chunks = 12